import styled, { css } from 'styled-components';
import { BreakPoint } from 'styles/style-variables/breakpoint';
import { EColors } from 'styles/style-variables/colors';
import { TransitionTime } from 'styles/style-variables/transition-time';

import { Button } from 'components/ui/Button';

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 160px;
`;

export const CounterButton = styled(Button)`
  width: 50%;
  min-height: 42px;
  padding: 10px;

  &:first-of-type {
    border-radius: 24px 0 0 24px;
  }

  &:last-of-type {
    border-radius: 0 24px 24px 0;
  }

  @media (max-width: ${BreakPoint.TabletTop}) {
    min-height: 32px;
    padding: 8px;
  }
`;

export const CounterInput = styled.input<{ $isInputFocused?: boolean }>`
  width: 100%;
  padding: 12px;
  border: none;
  ${({ $isInputFocused }) =>
    $isInputFocused
      ? css`
          background-color: transparent;
        `
      : css`
          background-color: ${EColors.Yellow3};
        `}
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  transition: background-color ${TransitionTime.Hover};
  outline: none;
  user-select: none;
  font-variant-numeric: tabular-nums;
`;
